import axiosInstance from '@/setup/axios/axiosInstance';

export interface RequestMaterialStatusOption {
  id: string;
  name: string;
  code?: string;
  color?: string;
  is_active?: boolean;
  sort_order?: number;
  company_id?: string | null;
}

interface ApiRequestMaterialStatus {
  id: string | number;
  name?: string;
  code?: string;
  color?: string;
  is_active?: boolean;
  sort_order?: number;
  company_id?: string | null;
}

const BASE_PATH = '/inventory/material-request-statuses/';

const unwrapListData = (data: any): ApiRequestMaterialStatus[] => {
  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  return [];
};

const mapStatus = (item: ApiRequestMaterialStatus): RequestMaterialStatusOption => ({
  id: String(item.id),
  name: item.name || item.code || String(item.id),
  code: item.code,
  color: item.color,
  is_active: item.is_active,
  sort_order: item.sort_order,
  company_id: item.company_id ?? null,
});

export const getRequestMaterialStatuses = async (companyId?: string): Promise<RequestMaterialStatusOption[]> => {
  const response = await axiosInstance.get(BASE_PATH, {
    params: companyId ? { company_id: companyId } : undefined,
  });

  return unwrapListData(response.data).map(mapStatus);
};

export const createRequestMaterialStatus = async (payload: {
  name: string;
  company_id?: string;
  code?: string;
  is_active?: boolean;
  sort_order?: number;
}): Promise<RequestMaterialStatusOption> => {
  const response = await axiosInstance.post(BASE_PATH, payload);
  return mapStatus(response.data);
};